$.widget("EASY.servicebarUtils" , $.EASY.Widget, {
    // Name is there for developers comfort especially in error reporting
    name:"Utilises servicebar",

    _customInit: function(){
        var self = this;
        var links = self.element.find('ul a');
        links.each(function (){
            var $this = $(this);
            $this.append($this.attr('title'));
        })

    },

    _customDestroy: function(){

    }

});

$.widget("EASY.fullScreenButton" , $.EASY.Widget, {
    // Name is there for developers comfort especially in error reporting
    name:"Fullscreen mode",

    content: null,

    state: null,

    _customInit: function() {
        var self = this;
        self.state = false;
        self.content = self.options.content;
        var $content = $(self.content);

        self.element.click( function(){
            if(!self.state){
                self.element.addClass('fullscreen__trigger_active');
                $content.addClass('fullscreen');
                self._toggleState();
            } else {
                self.element.removeClass('fullscreen__trigger_active');
                $content.removeClass('fullscreen');
                self._toggleState();
            }

        });
    }
});